import { connect } from "react-redux";
import { getToken } from "../../lib";
import * as actions from './actions';
import Questionnaire from './Questionnaire';

const mapStateToProps = (state, ownProps) => {
  return {
    questionnaires: state.questionnaires.questionnaires,
    results: state.questionnaires.results,
    isFetching: state.questionnaires.isFetchingList,
    success: state.questionnaires.success,
    templates: state.questionnaires.templates,
    isFetchingTemplates: state.questionnaires.isFetchingTemplates,
    templatedFetched: state.questionnaires.templatedFetched,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  getQuestionnaires: () => dispatch(actions.getQuestionnaires(getToken())),
  clearErrors: () => dispatch(actions.clearErrors()),
  getTemplates: () => dispatch(actions.getTemplates(getToken())),
  clearTemplateErros: () => dispatch(actions.clearTemplateErrors)
})

const QuestionnaireContainer = connect(mapStateToProps, mapDispatchToProps)(Questionnaire);

export default QuestionnaireContainer;


// WEBPACK FOOTER //
// src/routes/Questionnaire/QuestionnaireContainer.js